export interface RulerTick {
  pos: number;
  // Whole inches are always 'major'; sub-inch subdivisions only appear down to whichever level
  // stays legible at the current on-screen ppi (see buildTicks()).
  size: 'major' | 'half' | 'quarter' | 'eighth';
  label?: number;
}

// Subdivides down from whole inches to eighths, stopping at whichever level keeps adjacent
// minor ticks at least minSpacingPx apart on screen. ppi is fixed to the box's own size, but
// canvas2dScale (see design-3d.component.ts's updateCanvas2dScale()) shrinks or grows the
// on-screen result to fit the column, so the same box can need a coarser or finer subdivision at
// different viewport widths. Every candidate step is a power-of-two fraction of an inch, so
// accumulating by += step below never drifts off an exact eighth.
export function buildTicks(lengthInches: number, ppi: number, canvas2dScale: number, canvasMargin: number): RulerTick[] {
  const ticks: RulerTick[] = [];
  const effectivePpi = ppi * canvas2dScale;
  const minSpacingPx = 6;
  const step = [0.125, 0.25, 0.5, 1].find((candidate) => candidate * effectivePpi >= minSpacingPx) ?? 1;

  for (let inches = 0; inches <= lengthInches + 1e-6; inches += step) {
    const eighths = Math.round(inches * 8);
    const size: RulerTick['size'] =
      eighths % 8 === 0 ? 'major' : eighths % 4 === 0 ? 'half' : eighths % 2 === 0 ? 'quarter' : 'eighth';
    ticks.push({
      pos: Math.round(inches * ppi) + canvasMargin,
      size,
      label: size === 'major' ? Math.round(inches) : undefined,
    });
  }
  return ticks;
}
